import LoadingSpinner from 'common/ui/LoadingSpinner';
import { useAuth } from 'context/auth-context';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    const url = `/login?url=${location.pathname}`;

    return <Navigate to={url} />;
  }

  return children;
};

const GuestRoute = ({ children }) => {
  const { isLoading, isAuthenticated } = useAuth();

  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    const searchParams = new URLSearchParams(location.search);
    const redirectUrl = searchParams.get('url') || '/';

    return <Navigate to={redirectUrl} />;
  }

  return children;
};

export { GuestRoute, PrivateRoute };
